let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("4glJk")).then(() => parcelRequire('4gZJG'));